import {DataTable, View, ViewHeader} from "@variocube/app-ui";
import React, {useMemo} from "react";
import {useAsync} from "react-async-hook";
import {useInboxApi} from "../../api";
import {useLocalization} from "../../i18n";
import {useInboxColumns} from "../../useInboxColumns";

export function InboxAuditorList() {
	const {t} = useLocalization();
	const {queryInboxes} = useInboxApi();
	const query = useMemo(() => ({
		filter: "AUDITOR_EDITING",
	} as const), []);
	const {result, loading, error} = useAsync(queryInboxes, [query]);

	const columns = useInboxColumns();

	return (
		<View>
			<ViewHeader
				title={t("navigation.adminGroup.auditors")}
			/>
			<DataTable
				columns={columns}
				rows={result ?? []}
				loading={loading}
				error={error}
			/>
		</View>
	);
}
